import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  catchError,
  debounceTime,
  of,
  Subject,
  switchMap,
  takeUntil,
} from 'rxjs';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { SharedService } from '../../Shared/services/shared.service';
import { ApiResponce } from '../../Shared/interfaces/apiResponce.interface';
import { TrigerToastService } from '../../Shared/services/triger-toast.service';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { Gender } from '../../Shared/Enums/Gender.enum';
import { PlaceOrderObj } from '../../Shared/interfaces/placeOrderMenu.interface';
import { OrderService } from '../../Shared/services/order/order.service';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { DialogModule } from 'primeng/dialog';
import {
  GoogleApiService,
  Maps,
} from '../../Shared/services/google-api.service';

import { AddUserUtility } from './addUser.utility';
import { RegexDirective } from '../../Shared/directives/regex.directive';
import { TownsNameList } from '../../Shared/interfaces/townsList.interface';
import { BlockDetail } from '../../Shared/interfaces/blockDetails.interface';
import { TooltipModule } from 'primeng/tooltip';
import { RestaurantUser } from '../../Shared/interfaces/loginUserRes.interface';
import { SearchService } from '../../Shared/services/search.service';
import { MaxLengthDirective } from '../../Shared/directives/max-length.directive';
import { PlaceOrderCalculation } from '../../Shared/Common/placeOrderCal';
 import { fromEvent } from 'rxjs';
import {  map, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-call-center-add-user',
  standalone: true,
  imports: [
    CalendarModule,
    InputTextModule,
    ReactiveFormsModule,
    ButtonModule,
    DropdownModule,
    InputIconModule,
    IconFieldModule,
    CommonModule,
    DialogModule,
    RegexDirective,
    TooltipModule,
    MaxLengthDirective,
  ],
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
  providers: [AddUserUtility, PlaceOrderCalculation],
})
export class AddUserComponent implements OnInit, OnDestroy,AfterViewInit {
  private destroyPlaceOrderS$ = new Subject<void>();
  private mapCenterChange$ = new Subject<{ lat: number; lng: number }>();
  @ViewChild('search', { static: false }) searchElementRef!: ElementRef;
  @ViewChild('mapContainer', { static: false }) mapContainer!: ElementRef<HTMLDivElement>;
  @Input() localStorageData: any;
  @Input()  showCustomerDialogExt: { show: boolean; customer: boolean; address: boolean; isEdit: boolean; editAddressId: number; phoneNumber?: string } = {
    show: false,
    customer: false,
    address: false,
    isEdit: false,
    editAddressId: 0,
  };
  @Output() closeEmitter = new EventEmitter();
  placeOrderObj: PlaceOrderObj | null = null;
  genderArray: { id: string; option: string }[] = [];
  isFormSubmit: boolean = false;
  showCustomerDialog: { show: boolean; customer: boolean; address: boolean } = {
    show: false,
    customer: false,
    address: false,
  };

  userData!: RestaurantUser;
  predictions: any[] = [];

  userDetail: any;
  userDetailForm!: FormGroup;
  userDetailApiLoader: boolean = false;
  addCustomerLoader: boolean = false;
  activeAddressId: number = 0;
  selectedAddressId: string = '';
  showAddAddressBtn: boolean = false;
  showAddressFeilds: boolean = false;
  googleMapSession: Maps | null = null;
  visible: boolean = false;

  autocompleteInstance: google.maps.places.Autocomplete | null = null;
  placeChangedListener: google.maps.MapsEventListener | null = null;
  inputListener: any = null;
  minAutocompleteChars: number = 4;
  map: google.maps.Map | null = null;
  marker: google.maps.Marker | null = null;

  addressType: { id: number; option: string }[] = [
    {
      id: 3,
      option: 'House',
    },
    {
      id: 4,
      option: 'Flat',
    },
    {
      id: 5,
      option: 'Office',
    },
  ];

  townsList!: TownsNameList[];
  BlockNameList!: BlockDetail[];
  OutSearchData: any;
  currentDate: any;
  selected_branch: any;

  constructor(
    private placeOrderS: OrderService,
    private sharedS: SharedService,
    private toastS: TrigerToastService,
    private apiService: GoogleApiService,
    private ngZone: NgZone,
    private addUserU: AddUserUtility,
    private searchService: SearchService
  ) {
    this.genderArray = Object.keys(Gender).map((key) => ({
      id: (Gender as any)[key],
      option: key,
    }));

    this.userDetailForm = new FormGroup({
      first_name: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.email]),
      cell_num: new FormControl('', [
        Validators.required,
        Validators.minLength(11),
        Validators.maxLength(11),
      ]),
      date_birth: new FormControl(null),
      gender: new FormControl(''),
      address_type: new FormControl(3, [Validators.required]),
      location: new FormControl(''),
      latitude: new FormControl(''),
      longitude: new FormControl(''),
      town: new FormControl(''),
      block: new FormControl(''),
      street: new FormControl('', [Validators.required]),
    });

  }



  ngOnInit(): void {
    // this.defaultSearch();
    this.currentDate = new Date();
    this.getLocalStorageData();
    this.getPlaceOrderObj();
    this.getTownsList();
    if (

      this.placeOrderObj?.customer?.cell_num &&
      this.placeOrderObj?.isEdit
    ) {
      this.userDetailForm
        .get('cell_num')
        ?.setValue(this.placeOrderObj?.customer?.cell_num);

      this.sharedS
        .sendGetRequest(
          `get_customer_by_contact?contact_no=${this.placeOrderObj.customer?.cell_num}`
        )
        .subscribe({
          next: (res: ApiResponce) => {
            if (res.Success) {
              this.userDetail = res.Data;
            } else {
              this.toastS.showToast({
                Message: res.Message,
                shortMessage: 'Error!',
                type: 'error',
              });
            }
          },
          error: (err: any) => {
            console.error('Error:', err);
          },
        });
    } else {
      // this.userDetailForm
      //   .get('cell_num')
      //   ?.setValue(
      //     this.OutSearchData?.cell_num
      //       ? this.OutSearchData.cell_num
      //       : this.localStorageData?.user.restaurant_branch_idd
      //   );

      // this.sharedS
      //   .sendGetRequest(
      //     `get_customer_by_contact?contact_no=${
      //       this.OutSearchData?.cell_num
      //         ? this.OutSearchData?.cell_num
      //         : this.localStorageData?.user.restaurant_branch_idd
      //     }`
      //   )
      //   .subscribe({
      //     next: (res: ApiResponce) => {
      //       if (res.Success) {
      //         this.userDetail = res.Data;
      //       } else {
      //       }
      //     },
      //     error: (err: any) => {
      //       console.error('Error:', err);
      //     },
      //   });
    }
    this.userDetailForm.get('address_type')?.setValue(3);

    this.mapCenterChange$
      .pipe(
        debounceTime(500),
        takeUntil(this.destroyPlaceOrderS$)
      )
      .subscribe(({ lat, lng }) => {
        this.processMapCenterChange(lat, lng);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['showCustomerDialogExt']) {
      if (this.showCustomerDialogExt.isEdit && this.showCustomerDialogExt.customer) {
        this.editUserDetail();
      } else if (this.showCustomerDialogExt.isEdit && this.showCustomerDialogExt.address) {
        this.editAddress(this.showCustomerDialogExt.editAddressId);
      } else {
        this.openCustomerDialog(this.showCustomerDialogExt.customer, this.showCustomerDialogExt.address);
      }
    }
  }

 ngAfterViewInit(): void {
  setTimeout(() => {
    if (!this.searchElementRef) return;

    this.apiService.loadGoogleMapsAPI().then(() => {
      this.apiService.startAutocompleteSession();
      this.setupLocationSearch();
      this.initMap();
    });
  },0);
 }





 setupLocationSearch() {
  const input = this.searchElementRef.nativeElement as HTMLInputElement;

  fromEvent(input, 'input')
    .pipe(
      debounceTime(400),
      map(() => input.value.trim()),
      distinctUntilChanged()
    )
    .subscribe((value) => {
      if (!value || value.length < this.minAutocompleteChars) {
        this.predictions = [];
        return;
      }

      this.apiService.loadGoogleMapsAPI().then(() => {
        this.apiService.getPredictions(value).then((preds) => {
          this.ngZone.run(() => {
            this.predictions = preds;
          });
        });
      });
    });
}



 selectPlace(prediction: any) {
   this.apiService.getPlaceDetails(prediction.place_id).then((place) => {
     if (!place) return;

     const lat = place.geometry?.location?.lat();
     const lng = place.geometry?.location?.lng();


     this.userDetailForm.patchValue({
       location: place.formatted_address,
       latitude: lat ? String(lat) : null,
       longitude: lng ? String(lng) : null,
     });

     this.predictions = [];
     this.apiService.startAutocompleteSession();

     if (lat && lng) {
       if (!this.map && this.mapContainer) {
         this.initMap();
       }
       if (this.map) {
         this.updateMapPosition(lat, lng);
       }
     }
   });
 }

  initMap() {
    if (!this.mapContainer || this.map) return;

    const mapOptions: google.maps.MapOptions = {
      center: { lat: 28.9004, lng: 66.9388 },
      zoom: 6,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      zoomControl: true,
      styles: [
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'labels.text',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'poi.business',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'road.local',
          elementType: 'labels',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'transit',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
      ],
      clickableIcons: true,
      mapTypeControl: true,
      streetViewControl: false,
      fullscreenControl: true,
    };

    this.map = new google.maps.Map(
      this.mapContainer.nativeElement,
      mapOptions,
    );

    this.marker = new google.maps.Marker({
      position: { lat: 28.9004, lng: 66.9388 },
      map: this.map,
      icon: {
        url: '/assets/images/pen-marker.png',
        scaledSize: new google.maps.Size(18, 48),
      }
    });

    this.map.addListener('center_changed', () => {
      const center = this.map?.getCenter();
      if (center) {
        const lat = center.lat();
        const lng = center.lng();

        this.marker?.setPosition({ lat, lng });

        this.mapCenterChange$.next({ lat, lng });
      }
    });
  }

  updateMapPosition(lat: number, lng: number) {
    if (!this.map || !this.marker) return;

    const position = { lat, lng };
    this.marker.setPosition(position);
    this.map.panTo(position);
    this.map.setZoom(16);
  }

  processMapCenterChange(lat: number, lng: number) {
    this.userDetailForm.patchValue({
      latitude: lat.toString(),
      longitude: lng.toString(),
    });

    this.apiService.getAddressFromLatLng(lat, lng).then((address) => {
      this.userDetailForm.patchValue({
        location: address,
      });
    });
  }




  getLocalStorageData() {
    this.sharedS.getData().subscribe((val: any) => {
      this.userData = val.user;
      this.selected_branch = val.selected_branche;
    });
  }

  getGenderObjById(id: string) {
    const x = this.genderArray.find((option) => option.id == id);
    return x;
  }

  addAddress() {

    if (!this.placeOrderObj) return;

    if (!this.activeAddressId && this.placeOrderObj.order_type_id == 3) {
      this.toastS.showToast({
        Message: 'Please select an address first',
        shortMessage: 'Warning!',
        type: 'warn',
      });
      return
    }

    this.placeOrderObj.customer_id = this.userDetail.id;
    this.placeOrderObj.delivery_address_id = this.activeAddressId;
    this.placeOrderObj.customer = this.userDetail;
    this.placeOrderS.updatePlaceOrder(this.placeOrderObj);
    this.searchService.searchPhoneNo(this.userDetail);

    this.close();

  }


  showAddressFeild(val?: boolean) {
    if (!val) {
      this.showAddressFeilds = !this.showAddressFeilds;
    }
    this.userDetailForm.get('address_type')?.setValue(3);

    const addressFormControls = [
      'location',
      'longitude',
      'latitude',
      'town',
      'block',
      'address_type',
    ];
    this.updateControlerValidator(
      addressFormControls,
      this.showAddressFeilds ? 'add' : 'remove'
    );    
  }

  openCustomerDialog(customer: boolean, address: boolean) {

    if (!customer && !address) return;

    if (this.showCustomerDialogExt.phoneNumber) {
      this.userDetailForm.patchValue({
        cell_num: this.showCustomerDialogExt.phoneNumber
      });
    }

    const allFormControls = [
      'first_name',
      'cell_num',
      'location',
      'longitude',
      'latitude',
      'address_type',
      'town',
      'block',
    ];

    const customerFormControls = ['first_name', 'cell_num'];
    const addressFormControls = [
      'location',
      'longitude',
      'latitude',
      'town',
      'block',
      'address_type',
    ];

    // Reset all form controls by removing validation
    this.updateControlerValidator(allFormControls, 'remove');
    if (customer && address) {
      const orderTypeId = this.placeOrderObj?.order_type_id;
      // Check order type and apply appropriate validators
      if (orderTypeId === 3) {
        this.showAddressFeilds = true;
        this.updateControlerValidator(allFormControls, 'add');
      } else {
        this.showAddAddressBtn = true;
        this.updateControlerValidator(customerFormControls, 'add');
      }
    } else if (customer) {
      this.updateControlerValidator(customerFormControls, 'add');
    } else if (address) {
      this.showAddressFeilds = true;
      this.updateControlerValidator(addressFormControls, 'add');
    }

    // Set the dialog state
    this.showCustomerDialog = {
      show: true,
      customer: customer,
      address: address,
    };

    // Initialize Google Map session
    setTimeout(() => {
    if (this.searchElementRef) {
      this.apiService.loadGoogleMapsAPI().then(() => {
        this.apiService.startAutocompleteSession();
        this.setupLocationSearch();
        this.initMap();
      });
    }
  });
  }

 onPredictionSelect(pred: any) {

  this.userDetailForm.get('location')?.setValue(
    pred.structured_formatting.main_text +
    ', ' +
    pred.structured_formatting.secondary_text
  );

  this.predictions = [];


  this.apiService.getPlaceDetails(pred.place_id).then((details) => {

    if (details?.geometry?.location) {
      const loc = details.geometry.location;

      const lat = typeof loc.lat === 'function' ? loc.lat() : loc.lat;
      const lng = typeof loc.lng === 'function' ? loc.lng() : loc.lng;


      this.userDetailForm.get('latitude')?.setValue(lat.toString());
      this.userDetailForm.get('longitude')?.setValue(lng.toString());

      if (lat && lng) {
        if (!this.map && this.mapContainer) {
          this.initMap();
        }
        if (this.map) {
          this.updateMapPosition(lat, lng);
        }
      }
    } else {
    }
  });
}



  closeCustomerDialog() {
    this.selectedAddressId = '';
    this.userDetailForm.reset();
    this.showAddressFeilds = false;
    this.showAddressFeild(true);
    this.isFormSubmit = false;
    this.showCustomerDialog = {
      show: false,
      customer: false,
      address: false,
    };
  }

  onCustomerFormSave(data: FormGroup) {
    let { customer, address } = this.showCustomerDialog;
    let customer_id = this.userDetail?.customer_id ?? null;
    if (this.showAddressFeilds && customer && address) {
      this.addUserWithAddress(data);
      return;
    }
    if (customer && !address) {
      this.addCustomer(data);
    } else if (address && !customer) {
      this.callAddAddressApi(data, customer_id);
    }
  }

  checkInvalidFormControls() {
    const invalidControls = [];
    const controls = this.userDetailForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalidControls.push(name); // Add the name of the invalid control to the list
      }
    }

    if (invalidControls.length > 0) {
      invalidControls.forEach((control) => {
        this.userDetailForm.get(control)?.markAllAsTouched();
        // this.userDetailForm.get(control)?.updateValueAndValidity();
      });
    }
    // check and remove its Validation
    if (this.userData && this.userData.is_order_by_town === 1) {
      if (invalidControls.length > 0) {
        let townIsTrue = ['location'];
        townIsTrue.forEach((control) => {
          this.userDetailForm
            .get(control)
            ?.removeValidators([Validators.required]);
          this.userDetailForm.get(control)?.updateValueAndValidity();
        });
      }
    }

    // Log or use the list of invalid controls
  }

  addUserWithAddress(data: FormGroup) {
    console.log(data.valid);
    this.checkInvalidFormControls();

    if (data.valid) {
      //
      this.addCustomerLoader = true;
      this.addUserU.addUserWithAddress(data.value).subscribe({
        next: (res: any) => {
          this.addCustomerLoader = false;

          if (
            res.addUserResponse &&
            res.addUserResponse.Success &&
            res.addAddressResponse &&
            res.addAddressResponse.Success &&
            res.addAddressResponse.Data &&
            res.addUserResponse.Data
          ) {
            let detail = res.addUserResponse.Data;
            detail.addresses = [{ ...res.addAddressResponse.Data }];
            this.userDetail = detail;

            this.showAddressFeilds = false;
            this.showAddAddressBtn = false;
            this.closeCustomerDialog();
          } else {
            this.toastS.showToast({
              Message: res.Message,
              shortMessage: 'Error!',
              type: 'error',
            });
          }
        },
        error: (err) => {
          this.addCustomerLoader = false;
          console.error('Error submitting form:', err);
        },
      });
    }
  }

  editUserDetail() {
    const patchData: any = {
      first_name: this.userDetail.first_name,
      email: this.userDetail.email,
      cell_num: this.userDetail.cell_num,
      gender: this.getGenderObjById(this.userDetail.gender),
    };

    const dob = this.userDetail?.date_birth;
    const parsedDate = dob ? new Date(dob) : null;

    if (parsedDate && !isNaN(parsedDate.getTime())) {
      patchData.date_birth = parsedDate;
    }

    this.userDetailForm.patchValue(patchData);
    this.openCustomerDialog(true, false);
  }

  editAddress(address: any) {
    this.selectedAddressId = address.address_id;

    this.apiService
      .getAddressFromLatLng(address.latitude, address.longitude)
      .then((location) => {
        console.log(location);
        this.setAddressValueToForm(address, location);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  setAddressValueToForm(address: any, location: string) {
    this.userDetailForm.patchValue({
      location: location,
      latitude: address.latitude,
      longitude: address.longitude,
      town: address.town,
      block: address.block,
      street: address.address1,
      address_type: address.address_type_id ?? 3,
    });
    this.openCustomerDialog(false, true);

    if (address.latitude && address.longitude) {
      setTimeout(() => {
        this.apiService.loadGoogleMapsAPI().then(() => {
          if (!this.map && this.mapContainer) {
            this.initMap();
          }
          if (this.map) {
            this.updateMapPosition(parseFloat(address.latitude), parseFloat(address.longitude));
          }
        });
      }, 500);
    }
  }

  addCustomer(data: FormGroup) {
    this.isFormSubmit = true;
    let customer_id = this.userDetail?.customer_id ?? null;
    if (
      data.value.first_name &&
      data.value.cell_num &&
      data.value.cell_num.length > 10
    ) {
      this.addCustomerLoader = true;
      this.addUserU
        .callAddEditUserApi(
          data.value,
          customer_id
        )
        .subscribe({
          next: (res: any) => {
            this.addCustomerLoader = false;
            if (res.Success) {
              this.closeCustomerDialog();
              // this.userDetail = res.Data;
              if (this.placeOrderObj) {
                this.placeOrderObj.customer_id = res.Data.id;
                this.placeOrderObj.customer = res.Data;
                this.placeOrderS.updatePlaceOrder(this.placeOrderObj);
              }
              this.toastS.showToast({
                Message: res.Message,
                shortMessage: 'Success!',
                type: 'success',
              });
            } else {
              this.toastS.showToast({
                Message: res.Message ?? 'Something went wrong',
                shortMessage: 'Error!',
                type: 'error',
              });
            }
          },
          error: (err) => {
            this.addCustomerLoader = false;
            console.error('Error submitting form:', err);
          },
        });
    }
  }

  callAddAddressApi(data: FormGroup, customer_id: string) {
    this.isFormSubmit = true;
    if (
      (data.value.address_type &&
      data.value.street) ||
      (data.value.block && data.value.town))
     {
      this.addCustomerLoader = true;
      this.addUserU
        .callAddEditAddressApi(customer_id, data.value, this.selectedAddressId)
        .subscribe({
          next: (res: any) => {
            this.addCustomerLoader = false;
            if (res.Success) {
              if (this.selectedAddressId) {
                if (Array.isArray(this.userDetail.addresses)) {
                  for (let i = 0; i < this.userDetail.addresses.length; i++) {
                    const element = this.userDetail.addresses[i];
                    if (element.address_id == this.selectedAddressId) {
                      this.userDetail.addresses[i] = res.Data;
                      break;
                    }
                  }
                }
              } else {
                if (Array.isArray(this.userDetail.addresses)) {
                  this.userDetail.addresses.push(res.Data);
                } else {
                  this.userDetail.addresses = [{ ...res.Data }];
                }
              }
              if (this.placeOrderObj) {
                this.placeOrderObj.customer = this.userDetail;
                this.placeOrderS.updatePlaceOrder(this.placeOrderObj);
              }

              this.toastS.showToast({
                Message: res.Message,
                shortMessage: 'Success!',
                type: 'success',
              });
              this.closeCustomerDialog();
            } else if (res.status === 422) {
              this.toastS.showToast({
                Message: res.Message ?? 'Something went wrong.',
                shortMessage: 'Error!',
                type: 'error',
              });
            }
          },
          error: (err) => {
            this.addCustomerLoader = false;
            console.error('Error submitting form:', err);
          },
        });
    }
  }

  getPlaceOrderObj() {
    this.placeOrderS
      .getPlaceOrderObj()
      .pipe(takeUntil(this.destroyPlaceOrderS$))
      .subscribe((data: PlaceOrderObj | null) => {
        if (data) {
          this.placeOrderObj = data;
          if (this.placeOrderObj.customer) {
            this.userDetail = this.placeOrderObj.customer;
            this.activeAddressId = this.placeOrderObj.delivery_address_id ?? 0;
          } else {
            this.userDetail = null;
            this.activeAddressId = 0;
          }
        }
      });
  }

  updateControlerValidator(formControls: string[], action: string) {
    if (action == 'add') {
      formControls.forEach((control) => {
        this.userDetailForm.get(control)?.setValidators([Validators.required]);
        this.userDetailForm.get(control)?.updateValueAndValidity();
      });
    } else {
      formControls.forEach((control) => {
        this.userDetailForm
          .get(control)
          ?.removeValidators([Validators.required]);
        this.userDetailForm.get(control)?.updateValueAndValidity();
      });
    }
  }

  // Form Town And Block API's:

  getSelectedBlock(event: DropdownChangeEvent) {
    if (event.value) {
      this.userDetailForm.get('location')?.reset(); // Reset Both Control if Town change
      this.userDetailForm.get('location')?.updateValueAndValidity();
      this.userDetailForm.get('block')?.reset();
      this.userDetailForm.get('block')?.updateValueAndValidity();
      this.getBlockByTownId(event.value.id);
    }
  }

  getTownsList() {
    this.sharedS.sendGetRequest('get_towns').subscribe({
      next: (res: ApiResponce) => {
        if (res.Success) {
          this.townsList = res.Data;
        } else {
          this.townsList = [];
        }
      },
      error: (err: any) => {
        this.townsList = [];
      },
    });
    // console.log(this.townsList);
  }

  getBlockByTownId(town_id: number) {
    this.sharedS
      .sendGetRequest(`get_blocks_by_town_id?town_id=${town_id}`)
      .subscribe({
        next: (res: ApiResponce) => {
          if (res.Success) {
            this.BlockNameList = res.Data;
          } else {
            this.BlockNameList = [];
          }
        },
        error: (err: any) => {
          this.BlockNameList = [];
        },
      });
  }

  onBlockSelect(event: DropdownChangeEvent) {
    let blockDetail = event.value;
    if (blockDetail.latitude && blockDetail.longitude) {
      this.userDetailForm.get('latitude')?.patchValue(blockDetail.latitude);
      this.userDetailForm.get('longitude')?.patchValue(blockDetail.longitude);

      this.apiService.loadGoogleMapsAPI().then(() => {
        if (!this.map && this.mapContainer) {
          this.initMap();
        }
        if (this.map) {
          this.updateMapPosition(parseFloat(blockDetail.latitude), parseFloat(blockDetail.longitude));
        }
      });
    } else {
      console.warn(
        'Res. of Block API',
        'Lat',
        blockDetail.latitude,
        'lng',
        blockDetail.longitude
      );
    }
    //  if(event.value){
    //   this.apiService.getAddressFromLatLng(blockDetail.latitude, blockDetail.longitude)
    //   .then((location) => {
    //     // console.log(location);
    //     this.setAddressToAddField(location);
    //   })
    //   .catch((error) => {
    //     console.error('Error:', error);
    //   });
    //  }
  }

  // setAddressToAddField(address:any){
  //   this.userDetailForm.get('location')?.patchValue(address)
  // }

  getInputValue(event: any) {
    if (event.target.value.length >= 1) {
      let controlAry = ['town', 'block'];
      controlAry.forEach((control) => {
        this.userDetailForm
          .get(control)
          ?.removeValidators([Validators.required]);
        this.userDetailForm.get(control)?.updateValueAndValidity();
      });
    }
  }

  close() {
    this.closeEmitter.emit();
  }

  ngOnDestroy(): void {
    this.destroyPlaceOrderS$.next();
    this.destroyPlaceOrderS$.complete();
    this.mapCenterChange$.complete();
  }
}
